import type { ReactElement } from 'react';

import type { CatalogTemplate } from '../api/templates.api';

interface Props {
  template?: CatalogTemplate;
}

// WhatsApp-style preview of the selected reminder template (body + footer + buttons).
// Shows the raw {{n}} placeholders as they come in the template (no substitution) so the
// variable mapping stays visible.
const TemplateMessagePreview = ({ template }: Props): ReactElement => {
  const components = template?.provider?.components ?? [];
  const header = components.find((c) => c.type === 'HEADER');
  const body = components.find((c) => c.type === 'BODY');
  const footer = components.find((c) => c.type === 'FOOTER');
  const buttons = components.find((c) => c.type === 'BUTTONS')?.buttons ?? [];

  const headerText = header?.text ?? '';
  const bodyText = body?.text ?? '';
  const footerText = footer?.text ?? '';

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">Vista Previa del Mensaje</p>
      {template && body ? (
        <div className="space-y-2 rounded-2xl bg-neutral-100 p-4">
          {headerText && <p className="text-sm font-semibold text-text-default">{headerText}</p>}
          <p className="whitespace-pre-line text-sm text-text-default">{bodyText}</p>
          {footerText && <p className="text-xs text-text-muted">{footerText}</p>}
          {buttons.length > 0 && (
            <div className="space-y-1 pt-1">
              {buttons.map((btn, i) => (
                <div
                  key={`${btn.text}-${i}`}
                  className="rounded-md border border-border bg-card px-3 py-2 text-center text-sm font-medium text-text-brand"
                >
                  {btn.text}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-border bg-neutral-100 p-4 text-center text-xs text-text-muted">
          Selecciona un template para previsualizar el mensaje.
        </div>
      )}
    </div>
  );
};

export default TemplateMessagePreview;
